module.exports = __webpack_public_path__ + "img/send-60min.23deabac.png";